/* src/app/components/destination-multiselect/destination-multiselect.component.scss */
.destination-multiselect-container {
  width: 232px;
  min-height: 56px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: white;
  padding: 8px 12px;
  position: relative;
  opacity: 1;
  transform: rotate(0deg);
}
.field-label {
  display: block;
  width: 208px;
  height: 16px;
  margin-bottom: 8px;
  font-size: 16px;
  color: #333;
  opacity: 1;
  transform: rotate(0deg);
}
.selected-values {
  display: flex;
  flex-wrap: wrap;
  width: 208px;
  min-height: 38px;
  gap: 8px;
  margin-bottom: 4px;
  padding: 3px 0;
  opacity: 1;
  transform: rotate(0deg);
}
.selected-chip {
  display: inline-flex;
  align-items: center;
  background-color: #DFDBD7;
  min-width: 99px;
  height: 32px;
  border-radius: 8px;
  padding: 4px 8px;
  font-size: 14px;
  color: #333;
  opacity: 1;
  transform: rotate(0deg);
  border: none;
  flex-shrink: 0;
}
.chip-text {
  margin-right: 4px;
}
.chip-remove {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  font-size: 12px;
  color: #333;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
}
.chip-remove:hover {
  background-color: rgba(0, 0, 0, 0.1);
}
.input-container {
  width: 100%;
}
.destination-input {
  border: none;
  outline: none;
  width: 100%;
  min-width: 130px;
  font-size: 16px;
  padding: 4px 0;
  background: transparent;
}
.destination-input:focus {
  outline: none;
  box-shadow: none;
}
.destination-input:disabled {
  background-color: #f5f5f5;
  color: #999;
  cursor: not-allowed;
}
.dropdown-container {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: white;
  border: 1px solid #ccc;
  border-radius: 0 0 4px 4px;
  max-height: 240px;
  overflow-y: auto;
  z-index: 99999;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-top: 1px;
}
.dropdown-option {
  padding: 12px 16px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  font-size: 16px;
}
.dropdown-option:hover {
  background-color: #f5f5f5;
}
.dropdown-option.highlighted {
  background-color: #e3f2fd;
}
.dropdown-option.disabled {
  background-color: #f9f9f9;
  color: #ccc;
  cursor: not-allowed;
}
.dropdown-option:last-child {
  border-bottom: none;
}
.error-message {
  color: red;
  font-size: 14px;
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.svg-warning-icon {
  width: 16px;
  height: 16px;
}
.destination-multiselect-container:focus-within {
  border-color: #2196f3;
  box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.2);
}
/*# sourceMappingURL=destination-multiselect.component.css.map */
